import React from 'react';
import ExpenseQueuePage from './expenseQueue/ExpenseQueuePage';
import { REVIEW_MODE } from './expenseQueue/constants/modes';

// /profile/expense-review — ใช้ตาราง/hook ชุดเดียวกับ PaymentApproval.js (expenseQueue/) ต่างกันแค่
// config ใน expenseQueue/constants/modes.js (flag หลักคือ review_status — flag อิสระ ไม่ผูกกับ
// payment_approval_status หรือ status เลย)
export default function ExpenseReview({ title }) {
  return <ExpenseQueuePage title={title} mode={REVIEW_MODE} />;
}
